import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Submission } from 'src/types/shared/Assessments';

export const fetchSubmissionsRequest = createAction('fetchSubmissionsRequest');
export const fetchSubmissionsSuccess = createAction<Submission[]>('fetchSubmissionsSuccess');
export const fetchSubmissionsFailure = createAction('fetchSubmissionsFailure');

export const fetchSubmissions = (challengeID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchSubmissionsRequest());
    try {
        const { data } = await api.get<Submission[]>('admin/assessments/challenges/' + challengeID);

        dispatch(fetchSubmissionsSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchSubmissionsFailure, e as any);
    }
};
